// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1o9ZJ","signatureBlock":"Footer_signatureBlock__YaV1W","signature":"Footer_signature__3_XJo"};